export default "__VITE_ASSET__D8yBL3v1__"